import React, {useRef} from 'react';
import {Platform, Pressable, View} from 'react-native';

import {tileContainerStyles} from '../styles';
import {ProductTileContainerProps} from '../types';

function ProductTileContainer({
  item,
  onPress,
  disabled = false,
  testID,
  containerStyle,
  children,
}: ProductTileContainerProps) {
  const containerRef = useRef<View>(null);

  const handlePress = () => {
    if (!disabled && onPress) {
      // On web, blur focus before navigation to prevent aria-hidden focus trap
      if (Platform.OS === 'web') {
        const activeElement = document.activeElement as HTMLElement;
        activeElement?.blur?.();
      }
      onPress(item);
    }
  };

  return (
    <Pressable
      ref={containerRef}
      style={({pressed}) => [
        tileContainerStyles.container,
        containerStyle,
        pressed && tileContainerStyles.pressed,
      ]}
      onPress={handlePress}
      disabled={disabled || !onPress}
      testID={testID}>
      {children}
    </Pressable>
  );
}

export default ProductTileContainer;
